module.exports = __webpack_public_path__ + "static/media/CUSIS M.53ad696c.png";